import FormView from 'common/modules/formView/view';
import tpl from './template.html';

export default FormView.extend({ template: tpl });
